export class ProposedShipmentCreationResult {
  shipmentId?: number;
  mileage?: number;

  constructor(opts?: Partial<ProposedShipmentCreationResult>) {
    if (opts?.shipmentId != null) {
      this.shipmentId = opts.shipmentId;
    }

    if (opts?.mileage != null) {
      this.mileage = opts.mileage;
    }
  }
}
